function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.108,
  d: "M1.21058 2.5403C1.8646 2.5403 2.39479 2.01011 2.39479 1.35609C2.39479 0.702064 1.8646 0.171875 1.21058 0.171875C0.556556 0.171875 0.0263672 0.702064 0.0263672 1.35609C0.0263672 2.01011 0.556556 2.5403 1.21058 2.5403Z",
  fill: "#506383",
  fillOpacity: 0.25
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.399,
  d: "M8.57899 2.5403C9.23301 2.5403 9.7632 2.01011 9.7632 1.35609C9.7632 0.702064 9.23301 0.171875 8.57899 0.171875C7.92496 0.171875 7.39478 0.702064 7.39478 1.35609C7.39478 2.01011 7.92496 2.5403 8.57899 2.5403Z",
  fill: "#506383",
  fillOpacity: 0.25
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.702,
  d: "M15.9474 2.5403C16.6014 2.5403 17.1316 2.01011 17.1316 1.35609C17.1316 0.702064 16.6014 0.171875 15.9474 0.171875C15.2934 0.171875 14.7632 0.702064 14.7632 1.35609C14.7632 2.01011 15.2934 2.5403 15.9474 2.5403Z",
  fill: "#506383",
  fillOpacity: 0.25
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3158 2.5403C23.9698 2.5403 24.5 2.01011 24.5 1.35609C24.5 0.702064 23.9698 0.171875 23.3158 0.171875C22.6618 0.171875 22.1316 0.702064 22.1316 1.35609C22.1316 2.01011 22.6618 2.5403 23.3158 2.5403Z",
  fill: "#506383",
  fillOpacity: 0.25
});

var SvgIconFlyingOneWayLeft = function SvgIconFlyingOneWayLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 3,
    viewBox: "0 0 25 3",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFlyingOneWayLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconFlyingOneWay_left.12bc72d9.svg";
export { ForwardRef as ReactComponent };